import React, { createContext, useState, useEffect, useContext, useCallback, useMemo, useRef } from 'react';
import { Box, Layer, ThemeContext } from 'grommet';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { getGrandEmitter } from 'granite-admin/utils/grandEmitter';
import Toast from 'granite-admin/core/components/Toast';
import { ConfigContext } from '../ConfigProvider';
export const ToastContext = /*#__PURE__*/createContext();
export const useToast = () => {
  const {
    addToast,
    successToast,
    errorToast,
    infoToast,
    warningToast
  } = useContext(ToastContext);
  return {
    addToast,
    successToast,
    errorToast,
    infoToast,
    warningToast
  };
};
const ToastProvider = ({
  children
}) => {
  const config = useContext(ConfigContext);
  const theme = useContext(ThemeContext);
  const {
    toast
  } = config ?? {};
  const {
    duration,
    closeOnClick,
    showCloseBtn,
    maxCount
  } = toast ?? {};
  const {
    toast: {
      position: themePosition = 'top',
      margin: themeMargin,
      colors,
      styles,
      className
    }
  } = theme ?? {};
  const grandEmitter = useMemo(() => getGrandEmitter(), []);
  const [toastData, setToastData] = useState([]);
  const [offlineToastId, setOfflineToastId] = useState();
  const toastTimer = useRef();
  const removeEarliestToast = useCallback(id => {
    // if (id)
    setToastData(prev => prev.filter(d => d.uniqueId !== id));

    // else
    //   setToastData(prev => {
    //     let newData = [...prev];
    //     newData.shift();
    //     return newData;
    //   });
  }, []);
  const addNewToast = useCallback(data => {
    let uniqueId = Date.now();
    setToastData(prev => {
      let newData = [...prev];
      if (prev.length >= maxCount) {
        newData.shift();
      }
      return [...newData, {
        // open: true,
        message: data.message,
        status: data.status,
        redirect: data.redirect,
        uniqueId
      }];
    });
    return uniqueId;
  }, [maxCount]);
  const addToast = useCallback(_.throttle((message, config = {
    status: colors.success || 'status-ok',
    duration: duration || 2000,
    autoClose: true
  }) => {
    grandEmitter.emit('SHOW_TOAST', {
      message,
      status: config.status,
      duration: config.duration,
      autoClose: config.autoClose
    });
  }, 100, {
    leading: false,
    trailing: true
  }), [grandEmitter]);
  const successToast = useCallback((message, timeOut, autoClose = true) => {
    addToast(message, {
      status: colors.success || 'status-ok',
      duration: timeOut || duration,
      autoClose
    });
  }, [addToast, colors.success, duration]);
  const errorToast = useCallback((message, timeOut, autoClose = true) => {
    addToast(message, {
      status: colors.error || 'status-error',
      duration: timeOut || duration,
      autoClose
    });
  }, [addToast, colors.error, duration]);
  const warningToast = useCallback((message, timeOut, autoClose = true) => {
    addToast(message, {
      status: colors.warning || 'status-warning',
      duration: timeOut || duration,
      autoClose
    });
  }, [addToast, colors.warning, duration]);
  const infoToast = useCallback((message, timeOut, autoClose = true) => {
    addToast(message, {
      status: colors.info || 'info',
      duration: timeOut || duration,
      autoClose
    });
  }, [addToast, colors.info, duration]);
  useEffect(() => {
    const subscription = grandEmitter.getObservable().subscribe(event => {
      toastTimer.current = [];
      // let offlineToastId;
      switch (event.type) {
        case 'SHOW_TOAST':
          {
            // if (toastTimer.current.length) {
            //   clearTimeout(toastTimer?.current[0]);
            //   toastTimer.current.shift();
            //   removeEarliestToast();
            // }
            let id = addNewToast(event.data);
            if (!event.data.redirect && event.data.autoClose) {
              // toastTimer.current.push(setTimeout(removeEarliestToast, event.data.duration));
              setTimeout(() => removeEarliestToast(id), event.data.duration);
            }
          }
          break;
        case 'SHOW_OFFLINE_TOAST':
          setOfflineToastId(addNewToast(event.data));
          break;
        case 'SHOW_BACK_ONLINE_TOAST':
          successToast(event.data);
          setTimeout(() => removeEarliestToast(offlineToastId), 1000);
          break;
        default:
          break;
      }
    });
    return () => subscription.unsubscribe();
  }, [grandEmitter, duration, addNewToast, offlineToastId, removeEarliestToast, successToast]);
  return /*#__PURE__*/React.createElement(ToastContext.Provider, {
    value: {
      addToast,
      successToast,
      errorToast,
      warningToast,
      infoToast
    }
  }, children, toastData?.length ? /*#__PURE__*/React.createElement(Layer, {
    modal: false,
    position: themePosition,
    margin: themeMargin,
    responsive: false,
    plain: true,
    animation: false
  }, /*#__PURE__*/React.createElement(Box, {
    fill: true,
    gap: "medium"
  }, toastData.map(toast => /*#__PURE__*/React.createElement(Toast, {
    key: toast.uniqueId,
    uniqueId: toast.uniqueId,
    text: toast.message,
    background: toast.status,
    redirect: toast.redirect,
    className: className,
    styles: styles,
    setToastData: setToastData,
    themePosition: themePosition,
    closeOnClick: closeOnClick,
    showCloseBtn: showCloseBtn
  })))) : null);
};
ToastProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.node])
};
export { ToastProvider };